import React, { useState, useEffect } from 'react';
import {
  GridComponent, ColumnsDirective, ColumnDirective,
  Page, Selection, Toolbar, Inject, Sort, Filter, Search
} from '@syncfusion/ej2-react-grids';
import { Tabs, Tab, Select, MenuItem, FormControl, InputLabel, useMediaQuery } from '@mui/material';
import axios from "axios";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const getAvatar = (username) => {
  return `/avatars/${username}.jpg`;
};




const PERIODOS = [
  { key: 'semana_actual', label: 'Semana Actual' },
  { key: 'ultimos_7_dias', label: 'Últimos 7 días' },
  { key: 'mes_actual', label: 'Mes en Curso' },
];

const formatFechaCorta = (fechaStr) => {
  const dias = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
  const [y, m, d] = fechaStr.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  return `${dias[date.getDay()]} ${String(d).padStart(2, '0')}`;
};

const Finanzas = () => {
  const today = new Date();
  const [resumenVendedores, setResumenVendedores] = useState([]);
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1; // getMonth es 0-indexado

  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedVendedor, setSelectedVendedor] = useState('');
  const [detalleOrdenes, setDetalleOrdenes] = useState([]);
  const [loadingDetalle, setLoadingDetalle] = useState(false);
  const [todosVendedores, setTodosVendedores] = useState([]);
  const [selectedPeriodo, setSelectedPeriodo] = useState('semana_actual');
  const [produccionData, setProduccionData] = useState(null);
  const [loadingProduccion, setLoadingProduccion] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  useEffect(() => {
    const fetchTodosVendedores = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/users/resumen-vendedores/`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setTodosVendedores(response.data);
      } catch (error) {
        console.error("Error cargando lista de vendedores:", error);
      }
    };
    fetchTodosVendedores();
  }, []);

  useEffect(() => {
  const fetchResumen = async () => {
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/resumen-vendedores/?year=${selectedYear}&month=${selectedMonth}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setResumenVendedores(response.data);
    } catch (error) {
      console.error("Error cargando resumen de vendedores:", error);
    }
  };
  

  fetchResumen();
}, [selectedYear, selectedMonth]);

  useEffect(() => {
    if (selectedTab !== 2) return;
    const fetchProduccion = async () => {
      try {
        setLoadingProduccion(true);
        const token = localStorage.getItem('access_token');
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/ordenes/reporte-m2/?periodo=${selectedPeriodo}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setProduccionData(response.data);
      } catch (error) {
        console.error('Error cargando producción diaria:', error);
        setProduccionData(null);
      } finally {
        setLoadingProduccion(false);
      }
    };
    fetchProduccion();
  }, [selectedTab, selectedPeriodo]);

  useEffect(() => {
    if (!selectedVendedor) return;
    const fetchDetalle = async () => {
      try {
        setLoadingDetalle(true);
        const token = localStorage.getItem("access_token");
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/ordenes/reporte-mensual/?oyear=${selectedYear}&omonth=${selectedMonth}&ovendedor=${selectedVendedor}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setDetalleOrdenes(response.data.ordenes || []);
      } catch (error) {
        console.error("Error cargando detalle de órdenes:", error);
        setDetalleOrdenes([]);
      } finally {
        setLoadingDetalle(false);
      }
    };
    fetchDetalle();
  }, [selectedYear, selectedMonth, selectedVendedor]);

  // Generar lista de años desde 2024 hasta el actual
  const years = Array.from({ length: currentYear - 2024 + 1 }, (_, i) => 2024 + i);

  const months = [
    { value: 1, label: 'Enero' },
    { value: 2, label: 'Febrero' },
    { value: 3, label: 'Marzo' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Mayo' },
    { value: 6, label: 'Junio' },
    { value: 7, label: 'Julio' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Septiembre' },
    { value: 10, label: 'Octubre' },
    { value: 11, label: 'Noviembre' },
    { value: 12, label: 'Diciembre' },
  ];

  // Filtrar órdenes por año y mes
  const ordenesFiltradas = detalleOrdenes.filter(
    (o) => o.Año === selectedYear && o.Mes === selectedMonth
  );

  return (
    <div className="flex-1 overflow-y-auto p-2 md:p-4">
      <div className="bg-white rounded-3xl p-2 md:p-6">
      <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
        <p className="text-xl md:text-3xl font-extrabold tracking-tight text-slate-900">Finanzas</p>
        {isMobile ? (
          <Select
            value={selectedTab}
            onChange={(e) => setSelectedTab(e.target.value)}
            size="small"
            sx={{ minWidth: 150 }}
          >
            <MenuItem value={0}>Resumen Vendedores</MenuItem>
            <MenuItem value={1}>Detalle Órdenes</MenuItem>
            <MenuItem value={2}>Producción Diaria</MenuItem>
          </Select>
        ) : (
          <Tabs value={selectedTab} onChange={handleTabChange}
            sx={{
              '.MuiTab-root': { '&:hover': { color: '#FF743A' }, '&.Mui-selected': { color: '#FF743A' } },
              '.MuiTabs-indicator': { backgroundColor: '#FF743A' },
            }}
          >
            <Tab label="Resumen por Vendedor" />
            <Tab label="Detalle de Órdenes Aprobadas" />
            <Tab label="Producción Diaria" />
          </Tabs>
        )}
      </div>

      {/* --- INICIO DEL CÓDIGO MODIFICADO --- */}
      {/* TAB 0 - Resumen por Vendedor */}
      {selectedTab === 0 && (
        <div className="flex flex-wrap justify-center md:justify-start gap-8 p-4">
          {resumenVendedores.map((v) => (
            <div
  key={v.ID}
  className="relative w-80 h-[520px] rounded-3xl overflow-hidden shadow-xl transition-transform transform hover:scale-105 bg-gray-800"
>
    {/* Imagen arriba, ocupando solo la mitad */}
  <div className="h-2/3 w-full overflow-hidden">
    <img
      src={getAvatar(v.username)}
      alt={v.Nombre}
      className="w-full h-full object-cover"
    />
  </div>
              {/* Overlay suave para mejorar legibilidad del texto */}
              <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-[#FF743A]/40"></div>
            
              {/* Nombre del vendedor (similar a 'Sarah Johnson') */}
              <div className="absolute top-5 left-5">
      <p className="font-bold text-2xl text-white">{v.Nombre}</p>
      <p className="text-sm text-gray-200">Láminas de Control Solar</p>
    </div>

              {/* Panel inferior con Glassmorphism */}
              <div className="absolute bottom-0 left-0 right-0 h-auto p-5 
  bg-gradient-to-t from-[#FF743A]/60 via-[#FF743A]/20 to-transparent 
  backdrop-blur-lg rounded-t-3xl border-t border-white/10 ">
                
                {/* Stats (Metros y Monto) */}
                <div className="flex justify-around text-center text-white mb-5">
                  <div>
                    <p className="text-2xl font-bold">{parseFloat(v.Metros)}</p>
                    <span className="text-xs font-light">m²</span>
                  </div>
                  <div>
                    <p className="text-2xl font-bold">{v.Monto.toLocaleString("es-CL", { style: "currency", currency: "CLP", minimumFractionDigits: 0 })}</p>
                    <span className="text-xs font-light">Monto Total</span>
                  </div>
                </div>

                {/* Selectores de fecha */}
                <div className="flex gap-3 mb-5">
                  <FormControl size="small" fullWidth>
                    <Select
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(Number(e.target.value))}
                      sx={{
                        color: 'white',
                        '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
                        '.MuiSvgIcon-root': { color: 'white' },
                        borderRadius: '0.75rem',
                      }}
                    >
                      {years.map((year) => <MenuItem key={year} value={year}>{year}</MenuItem>)}
                    </Select>
                  </FormControl>
                  <FormControl size="small" fullWidth>
                    <Select
                      value={selectedMonth}
                      onChange={(e) => setSelectedMonth(Number(e.target.value))}
                       sx={{
                        color: 'white',
                        '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
                        '.MuiSvgIcon-root': { color: 'white' },
                        borderRadius: '0.75rem',
                      }}
                    >
                      {months
                        .filter((m) => selectedYear < currentYear || m.value <= currentMonth)
                        .map((m) => <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>)}
                    </Select>
                  </FormControl>
                </div>

                {/* Botón de descarga */}
<button
  type="button"
  className="w-full bg-[#FF743A] text-white px-4 py-3 rounded-xl shadow-lg hover:opacity-90 transition-opacity font-semibold"
  onClick={async () => {
    try {
      const html2pdf = (await import('html2pdf.js/dist/html2pdf.bundle.min.js')).default;

      // 🔹 Cargar el template desde public
      const response = await fetch('/PDFUsuarios.html');
      let templateHTML = await response.text();

      // 🔹 Variables seguras con fallbacks
      const safeUsername = v.username || 'usuario';
      const safeNombre = v.Nombre || safeUsername;
      const safeMetros = Number(v.Metros || 0).toFixed(2);
      const safeMonto = Number(v.Monto || 0).toLocaleString("es-CL", { style: "currency", currency: "CLP" });
      const safeMes = months.find(m => m.value === selectedMonth)?.label || '';

      // 🔹 Reemplazar variables del template
      const logoUrl = `${window.location.origin}/logo-filmsolar_naranja.svg`;
      const avatarUrl = `${window.location.origin}${getAvatar(v.username)}`;
      templateHTML = templateHTML
        .replace('./logo-filmsolar_naranja.svg', logoUrl)
        .replace('{{fotoUsuario}}', avatarUrl)
        .replace('{{nombreUsuario}}', safeNombre)
        .replace('{{metros}}', safeMetros)
        .replace('{{monto}}', safeMonto)
        .replace('{{anio}}', selectedYear)
        .replace('{{mes}}', safeMes);

      // 🔹 Crear nodo temporal
      const element = document.createElement("div");
      element.innerHTML = templateHTML;
      document.body.appendChild(element);

      // 🔹 Configuración PDF
      const opt = {
        filename: `reporte_${safeUsername}_${selectedYear}-${selectedMonth}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, imageTimeout: 0 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      // 🔹 Generar PDF
      await html2pdf().from(element).set(opt).save();

      // 🔹 Eliminar nodo temporal
      document.body.removeChild(element);
    } catch (err) {
      console.error("Error generando PDF:", err);
      alert("No se pudo generar el PDF.");
    }
  }}
>
  Descargar PDF
</button>
              </div>
            </div>
          ))}
        </div>
      )}
      {/* --- FIN DEL CÓDIGO MODIFICADO --- */}

      {/* TAB 1 - Detalle de Órdenes Aprobadas */}
      {selectedTab === 1 && (
        <>
          <div className="flex flex-wrap gap-4 mb-4 items-end">
            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel>Año</InputLabel>
              <Select
                value={selectedYear}
                label="Año"
                onChange={(e) => setSelectedYear(Number(e.target.value))}
              >
                {years.map((year) => (
                  <MenuItem key={year} value={year}>{year}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 150 }}>
              <InputLabel>Mes</InputLabel>
              <Select
                value={selectedMonth}
                label="Mes"
                onChange={(e) => setSelectedMonth(Number(e.target.value))}
              >
                {months
                  .filter(m => selectedYear < currentYear || m.value <= currentMonth)
                  .map(m => (
                    <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
                  ))}
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 180 }}>
              <InputLabel shrink>Vendedor</InputLabel>
              <Select
                value={selectedVendedor}
                label="Vendedor"
                displayEmpty
                onChange={(e) => setSelectedVendedor(e.target.value)}
              >
                <MenuItem value="">-- Selecciona --</MenuItem>
                {todosVendedores.map((v) => (
                  <MenuItem key={v.ID} value={v.username}>{v.Nombre}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {loadingDetalle ? (
            <p className="text-gray-500 mt-4">Cargando órdenes...</p>
          ) : !selectedVendedor ? (
            <p className="text-gray-400 mt-4">Selecciona un vendedor para ver el detalle.</p>
          ) : (
            <GridComponent
              dataSource={detalleOrdenes}
              allowPaging
              pageSettings={{ pageCount: 5 }}
              toolbar={['Search']}
              allowSorting
              className="mt-4"
            >
              <ColumnsDirective>
                <ColumnDirective field="Cotizacion" headerText="Cotización" width="130" textAlign="Center" />
                <ColumnDirective field="Orden" headerText="Orden" width="120" textAlign="Center" />
                <ColumnDirective field="Cliente" headerText="Cliente" width="180" />
                <ColumnDirective field="Comuna" headerText="Comuna" width="140" />
                <ColumnDirective field="Metros" headerText="m²" width="90" textAlign="Center" />
                <ColumnDirective field="Monto" headerText="Monto" width="140" textAlign="Center" format="C0" />
                <ColumnDirective field="Estado" headerText="Estado" width="120" textAlign="Center" />
                <ColumnDirective field="fecha_aprobacion" headerText="Aprobación" width="160" textAlign="Center" />
              </ColumnsDirective>
              <Inject services={[Page, Selection, Toolbar, Sort, Filter, Search]} />
            </GridComponent>
          )}
        </>
      )}
      {/* TAB 2 - Producción Diaria */}
      {selectedTab === 2 && (
        <div className="p-2 md:p-4">
          {/* Selector de período */}
          <div className="flex flex-wrap gap-2 mb-6">
            {PERIODOS.map((p) => (
              <button
                key={p.key}
                type="button"
                onClick={() => setSelectedPeriodo(p.key)}
                className={`px-4 py-2 rounded-xl font-semibold text-sm transition-colors ${
                  selectedPeriodo === p.key
                    ? 'bg-[#FF743A] text-white shadow-md'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {p.label}
              </button>
            ))}
          </div>

          {loadingProduccion ? (
            <p className="text-gray-500">Cargando datos...</p>
          ) : !produccionData ? (
            <p className="text-gray-400">No se pudieron cargar los datos.</p>
          ) : (() => {
            const dias = produccionData.resumen_por_dia || [];
            const maxM2 = Math.max(...dias.map((d) => d.m2_total), 1);
            const diasConActividad = dias.filter((d) => d.m2_total > 0);
            const mejorDia = diasConActividad.reduce(
              (best, d) => (!best || d.m2_total > best.m2_total ? d : best),
              null
            );
            const promedio = diasConActividad.length > 0
              ? produccionData.total_m2 / diasConActividad.length
              : 0;

            return (
              <>
                {/* KPI Cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                  <div className="bg-gradient-to-br from-[#FF743A] to-[#ff9a6c] rounded-2xl p-5 text-white shadow-lg">
                    <p className="text-sm opacity-80 mb-1">Total m²</p>
                    <p className="text-4xl font-extrabold">{produccionData.total_m2.toFixed(2)}</p>
                    <p className="text-xs opacity-70 mt-1">
                      {produccionData.fecha_inicio} → {produccionData.fecha_fin}
                    </p>
                  </div>
                  <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
                    <p className="text-sm text-gray-500 mb-1">Mejor día</p>
                    {mejorDia ? (
                      <>
                        <p className="text-3xl font-extrabold text-slate-800">
                          {mejorDia.m2_total.toFixed(2)}
                          <span className="text-base font-normal text-gray-400 ml-1">m²</span>
                        </p>
                        <p className="text-xs text-gray-400 mt-1">
                          {formatFechaCorta(mejorDia.fecha)} · {mejorDia.instalaciones} instalaciones
                        </p>
                      </>
                    ) : (
                      <p className="text-2xl font-bold text-slate-400">—</p>
                    )}
                  </div>
                  <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
                    <p className="text-sm text-gray-500 mb-1">Promedio diario</p>
                    <p className="text-3xl font-extrabold text-slate-800">
                      {promedio.toFixed(2)}
                      <span className="text-base font-normal text-gray-400 ml-1">m²/día</span>
                    </p>
                    <p className="text-xs text-gray-400 mt-1">
                      sobre {diasConActividad.length} día{diasConActividad.length !== 1 ? 's' : ''} con actividad
                    </p>
                  </div>
                </div>

                {/* Gráfico de barras */}
                <div className="bg-gray-50 rounded-2xl p-4 mb-6">
                  <p className="text-sm font-semibold text-slate-600 mb-4">m² instalados por día</p>
                  <div className="overflow-x-auto">
                    <div className="flex items-end gap-1 md:gap-2 min-w-fit" style={{ height: '150px' }}>
                      {dias.map((d) => {
                        const heightPct = d.m2_total > 0 ? Math.max((d.m2_total / maxM2) * 100, 4) : 0;
                        return (
                          <div
                            key={d.fecha}
                            className="flex flex-col items-center gap-1 flex-1 min-w-[38px]"
                            style={{ height: '100%', justifyContent: 'flex-end' }}
                          >
                            {d.m2_total > 0 && (
                              <span className="text-[10px] font-semibold text-[#FF743A]">
                                {d.m2_total.toFixed(1)}
                              </span>
                            )}
                            <div
                              className={`w-full rounded-t-lg transition-all ${
                                d.m2_total > 0 ? 'bg-[#FF743A]' : 'bg-gray-200'
                              }`}
                              style={{ height: `${heightPct}%` }}
                              title={`${formatFechaCorta(d.fecha)}: ${d.m2_total.toFixed(2)} m²`}
                            />
                            <span className="text-[10px] text-gray-400 whitespace-nowrap">
                              {formatFechaCorta(d.fecha)}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {/* Detalle por vendedor */}
                {produccionData.detalle_por_vendedor?.length > 0 && (
                  <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
                    <p className="font-bold text-slate-700 mb-4">Detalle por vendedor</p>
                    <div className="space-y-3">
                      {[...produccionData.detalle_por_vendedor]
                        .sort((a, b) => b.m2_total - a.m2_total)
                        .map((v) => {
                          const pct = produccionData.total_m2 > 0
                            ? (v.m2_total / produccionData.total_m2) * 100
                            : 0;
                          return (
                            <div key={v.vendedor} className="flex items-center gap-3">
                              <p className="w-36 md:w-44 text-sm font-medium text-slate-700 truncate shrink-0">
                                {v.vendedor}
                              </p>
                              <div className="flex-1 bg-gray-100 rounded-full h-3">
                                <div
                                  className="bg-[#FF743A] h-3 rounded-full transition-all"
                                  style={{ width: `${pct}%` }}
                                />
                              </div>
                              <p className="text-sm font-bold text-slate-800 w-20 text-right shrink-0">
                                {v.m2_total.toFixed(2)} m²
                              </p>
                              <p className="text-xs text-gray-400 w-10 text-right shrink-0">
                                {pct.toFixed(0)}%
                              </p>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}

                {/* Botón Descargar PDF */}
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    className="bg-[#FF743A] text-white px-6 py-3 rounded-xl shadow-lg hover:opacity-90 transition-opacity font-semibold flex items-center gap-2"
                    onClick={async () => {
                      try {
                        const doc = new jsPDF({ unit: 'mm', format: 'a4' });
                        const pageWidth = doc.internal.pageSize.width;
                        const pageHeight = doc.internal.pageSize.height;
                        const ml = 15;
                        const mr = 15;

                        const orange    = [255, 116, 58];
                        const blue      = [37,  109, 159];
                        const darkText  = [40,  40,  40];
                        const mutedText = [120, 120, 120];
                        const lightGray = [245, 245, 245];

                        // ── Cargar logo SVG → canvas → base64 ──
                        let logoBase64 = null;
                        try {
                          const svgText = await fetch(`${window.location.origin}/logo-filmsolar.svg`).then(r => r.text());
                          const blob = new Blob([svgText], { type: 'image/svg+xml' });
                          const blobUrl = URL.createObjectURL(blob);
                          logoBase64 = await new Promise((resolve) => {
                            const img = new Image();
                            img.onload = () => {
                              const canvas = document.createElement('canvas');
                              canvas.width  = 759 * 2;
                              canvas.height = 116 * 2;
                              canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
                              URL.revokeObjectURL(blobUrl);
                              resolve(canvas.toDataURL('image/png'));
                            };
                            img.onerror = () => { URL.revokeObjectURL(blobUrl); resolve(null); };
                            img.src = blobUrl;
                          });
                        } catch (_) { /* logo opcional */ }

                        // ── Header azul ──
                        const headerH = 32;
                        doc.setFillColor(...blue);
                        doc.rect(0, 0, pageWidth, headerH, 'F');

                        // Logo izquierda (aspect ratio SVG: 759.44 / 115.94 ≈ 6.55)
                        const logoW = 52;
                        const logoH = logoW / (759.44 / 115.94); // ~7.9 mm
                        const logoY = (headerH - logoH) / 2;
                        if (logoBase64) {
                          doc.addImage(logoBase64, 'PNG', ml, logoY, logoW, logoH);
                        }

                        // Título derecha, centrado verticalmente
                        doc.setFont('helvetica', 'bold');
                        doc.setFontSize(15);
                        doc.setTextColor(255, 255, 255);
                        doc.text('Reporte de Producción Diaria', pageWidth - mr, headerH / 2 - 2, { align: 'right' });

                        const periodoLabel = PERIODOS.find(p => p.key === selectedPeriodo)?.label || '';
                        doc.setFontSize(8);
                        doc.setFont('helvetica', 'normal');
                        doc.setTextColor(200, 225, 245);
                        doc.text(periodoLabel, pageWidth - mr, headerH / 2 + 4, { align: 'right' });
                        doc.text(
                          `${produccionData.fecha_inicio} al ${produccionData.fecha_fin}`,
                          pageWidth - mr, headerH / 2 + 9,
                          { align: 'right' }
                        );

                        let y = headerH + 10;

                        // ── KPI boxes ──
                        const boxW = (pageWidth - ml - mr - 10) / 3;
                        const kpiItems = [
                          { label: 'Total m²',        value: `${produccionData.total_m2.toFixed(2)} m²` },
                          { label: 'Mejor día',        value: mejorDia ? `${formatFechaCorta(mejorDia.fecha)}: ${mejorDia.m2_total.toFixed(2)} m²` : '—' },
                          { label: 'Promedio diario',  value: `${promedio.toFixed(2)} m²/día` },
                        ];

                        kpiItems.forEach((k, i) => {
                          const bx = ml + i * (boxW + 5);
                          doc.setFillColor(...lightGray);
                          doc.roundedRect(bx, y, boxW, 20, 2, 2, 'F');
                          doc.setFontSize(8);
                          doc.setFont('helvetica', 'normal');
                          doc.setTextColor(...mutedText);
                          doc.text(k.label, bx + 4, y + 6);
                          doc.setFontSize(10);
                          doc.setFont('helvetica', 'bold');
                          doc.setTextColor(...darkText);
                          doc.text(k.value, bx + 4, y + 15);
                        });

                        y += 28;

                        // ── Tabla diaria ──
                        doc.setFontSize(10);
                        doc.setFont('helvetica', 'bold');
                        doc.setTextColor(...darkText);
                        doc.text('Resumen por día', ml, y);
                        y += 2;

                        doc.autoTable({
                          startY: y,
                          margin: { left: ml, right: mr },
                          head: [['Fecha', 'Día', 'm²', 'Instalaciones']],
                          body: dias.map(d => [
                            d.fecha,
                            formatFechaCorta(d.fecha),
                            d.m2_total.toFixed(2) + ' m²',
                            d.instalaciones.toString(),
                          ]),
                          styles: { fontSize: 9, textColor: darkText },
                          headStyles: { fillColor: orange, textColor: [255, 255, 255], fontStyle: 'bold' },
                          columnStyles: { 2: { halign: 'right' }, 3: { halign: 'center' } },
                          alternateRowStyles: { fillColor: lightGray },
                        });

                        y = doc.lastAutoTable.finalY + 10;

                        // ── Tabla vendedores ──
                        doc.setFontSize(10);
                        doc.setFont('helvetica', 'bold');
                        doc.setTextColor(...darkText);
                        doc.text('Detalle por vendedor', ml, y);
                        y += 2;

                        doc.autoTable({
                          startY: y,
                          margin: { left: ml, right: mr },
                          head: [['Vendedor', 'm² Total', '% del Total']],
                          body: [...produccionData.detalle_por_vendedor]
                            .sort((a, b) => b.m2_total - a.m2_total)
                            .map(v => [
                              v.vendedor,
                              v.m2_total.toFixed(2) + ' m²',
                              produccionData.total_m2 > 0
                                ? ((v.m2_total / produccionData.total_m2) * 100).toFixed(1) + '%'
                                : '0%',
                            ]),
                          styles: { fontSize: 9, textColor: darkText },
                          headStyles: { fillColor: orange, textColor: [255, 255, 255], fontStyle: 'bold' },
                          columnStyles: { 1: { halign: 'right' }, 2: { halign: 'center' } },
                          alternateRowStyles: { fillColor: lightGray },
                          foot: [['TOTAL', produccionData.total_m2.toFixed(2) + ' m²', '100%']],
                          footStyles: { fillColor: orange, textColor: [255, 255, 255], fontStyle: 'bold' },
                        });

                        // ── Footer ──
                        doc.setFontSize(8);
                        doc.setFont('helvetica', 'normal');
                        doc.setTextColor(...mutedText);
                        doc.text(
                          'Film Solar Spa · +56 9 66781957 · www.filmsolar.cl',
                          pageWidth / 2,
                          pageHeight - 8,
                          { align: 'center' }
                        );

                        doc.save(
                          `produccion_${selectedPeriodo}_${new Date().toISOString().split('T')[0]}.pdf`
                        );
                      } catch (err) {
                        console.error('Error generando PDF:', err);
                        alert('No se pudo generar el PDF.');
                      }
                    }}
                  >
                    Descargar PDF
                  </button>
                </div>
              </>
            );
          })()}
        </div>
      )}

      </div>
    </div>
  );
};

export default Finanzas;
